import React, { useMemo } from 'react';
import { OPERATORS } from '../nodeConfig';

export default function ConditionalSettings({ cfg, data, update }) {
  // Evaluate a single rule (from rules array or legacy)
  const evaluateRule = (rule, values) => {
    const left = values[rule.left] ?? '';
    const right = rule.right ?? '';

    switch (rule.operator) {
      case 'equals': return left === right;
      case 'not_equals': return left !== right;
      case 'contains': return left.includes(right);
      case 'not_contains': return !left.includes(right);
      case 'starts_with': return left.startsWith(right);
      case 'ends_with': return left.endsWith(right);
      case 'exists': return left !== undefined && left !== null;
      case 'is_empty': return left === '' || left === null || left === undefined;
      default: return false;
    }
  };

  // Compute boolean result from rules + legacy fields
  const booleanResult = useMemo(() => {
    // Prepare values: map legacy source/value
    const values = { [cfg.source]: cfg.value ?? '' };

    // Evaluate rules array
    const rulesResults = (cfg.rules || []).map((rule) => evaluateRule(rule, values));

    // Include legacy single rule if defined separately
    const legacyResult = cfg.source && cfg.operator && cfg.value
      ? evaluateRule({ left: cfg.source, operator: cfg.operator, right: cfg.value }, values)
      : true; // if no legacy, default true for AND

    const combinedResults = [...rulesResults, legacyResult];

    // Apply match logic
    if (cfg.logic === 'all') return combinedResults.every(Boolean);
    if (cfg.logic === 'any') return combinedResults.some(Boolean);
    return false;
  }, [cfg.rules, cfg.logic, cfg.source, cfg.operator, cfg.value]);

  return (
    <div className="mt-2 grid gap-2">
      {/* Legacy fields */}
      <div className="grid gap-2 grid-cols-1 sm:grid-cols-3">
        <label className="grid gap-1 text-xs text-slate-700">
          Source (Legacy)
          <input
            className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20"
            value={cfg.source || ''}
            onChange={(e) => update({ source: e.target.value })}
            placeholder="message.text.body"
          />
        </label>
        <label className="grid gap-1 text-xs text-slate-700">
          Operator (Legacy)
          <select
            className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20"
            value={cfg.operator || 'contains'}
            onChange={(e) => update({ operator: e.target.value })}
          >
            {OPERATORS.map((op) => (
              <option key={op} value={op}>{op}</option>
            ))}
          </select>
        </label>
        <label className="grid gap-1 text-xs text-slate-700">
          Value (Legacy)
          <input
            className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20"
            value={cfg.value || ''}
            onChange={(e) => update({ value: e.target.value })}
            placeholder="price"
          />
        </label>
      </div>

      {/* Match logic */}
      {/* <label className="grid gap-1 text-xs text-slate-700">
        Match Logic
        <select
          className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20"
          value={cfg.logic}
          onChange={(e) => update({ logic: e.target.value })}
        >
          <option value="all">All rules match (AND)</option>
          <option value="any">Any rule matches (OR)</option>
        </select>
      </label> */}

      {/* Rules array */}
      {/* <div className="grid gap-2">
        {(cfg.rules || []).map((rule) => (
          <div key={rule.id} className="grid gap-2 grid-cols-1 lg:grid-cols-[1.2fr_1fr_1fr_auto]">
            <input
              className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20"
              value={rule.left}
              onChange={(e) => data.onRulePatch(rule.id, { left: e.target.value })}
              placeholder="variable"
            />
            <select
              className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20"
              value={rule.operator}
              onChange={(e) => data.onRulePatch(rule.id, { operator: e.target.value })}
            >
              {OPERATORS.map((op) => (
                <option key={op} value={op}>{op}</option>
              ))}
            </select>
            <input
              className="nodrag w-full rounded-lg border border-slate-300 bg-white px-2 py-1.5 text-xs text-slate-900 outline-none focus:border-green-600 focus:ring-2 focus:ring-green-600/20"
              value={rule.right}
              onChange={(e) => data.onRulePatch(rule.id, { right: e.target.value })}
              placeholder="value"
            />
            <button
              className="nodrag rounded-md border border-slate-300 bg-white px-2 py-1 text-xs font-semibold text-slate-700"
              onClick={() => data.onRuleRemove(rule.id)}
            >
              x
            </button>
          </div>
        ))}
        <button
          className="nodrag w-fit rounded-md border border-slate-300 bg-white px-2 py-1 text-xs font-semibold text-slate-700"
          onClick={data.onRuleAdd}
        >
          + Add Rule
        </button>
      </div> */}

      {/* Boolean preview + branch hint */}
      {/* <div className="mt-2 p-2 rounded bg-slate-100 text-xs text-slate-800">
        <strong>Conditional Result:</strong> {booleanResult ? 'TRUE' : 'FALSE'}
      </div>
      <div className="mt-1 p-1 rounded bg-slate-50 text-xs text-slate-600">
        This node will follow the <strong>{booleanResult ? 'TRUE' : 'FALSE'}</strong> branch.
      </div> */}
    </div>
  );
}